"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[843],{

/***/ 7282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _categoryItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8340);
/* harmony import */ var _data_categories_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3996);
/* harmony import */ var _dropdown_recently_added_dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7668);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _redux_counterSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8362);
/* harmony import */ var _demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9023);
/* harmony import */ var lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6833);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(406);













var dafault_tranding_category_filter_data = [
    {
        id: 0,
        svg: "public",
        text: "public"
    },
    {
        id: 1,
        svg: "private",
        text: "private"
    },
    {
        id: 2,
        text: "all"
    }
];
var public_tranding_category_filter_data = [
    {
        id: 0,
        svg: "public",
        text: "public"
    }
];
var private_tranding_category_filter_data = [
    {
        id: 1,
        svg: "private",
        text: "private"
    }, 
];
function loadUserWalletContent(publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections) {
    return _loadUserWalletContent.apply(this, arguments);
}
function _loadUserWalletContent() {
    _loadUserWalletContent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections) {
        var is_externals_tokens, is_private_tokens, inludes_public_tokens, user_collections, ownedTokens, records, private_tokens, _, private_tokens1, ownedTokens1, e, ref, err_str;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loading || !publicKey || !requestRecords) return [
                        2
                    ];
                    setLoading(true);
                    is_externals_tokens = filterVal === 3;
                    is_private_tokens = filterVal === 1 || filterVal === 2;
                    inludes_public_tokens = filterVal === 0 || filterVal === 2;
                    user_collections = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        13,
                        ,
                        14
                    ]);
                    if (!!is_externals_tokens) return [
                        3,
                        9
                    ];
                    ownedTokens = [];
                    return [
                        4,
                        requestRecords("aleo_store_nft.aleo")
                    ];
                case 2:
                    records = _state.sent() || [];
                    records = records.filter(function(record) {
                        return !record.spent;
                    });
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .get_user_collections */ .iV)(publicKey, requestRecords, records)
                    ];
                case 3:
                    user_collections = _state.sent();
                    if (!is_private_tokens) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .get_user_private_tokens */ .hF)(publicKey, requestRecords, records)
                    ];
                case 4:
                    private_tokens = _state.sent();
                    ownedTokens = ownedTokens.concat(private_tokens);
                    _state.label = 5;
                case 5:
                    if (!inludes_public_tokens) return [
                        3,
                        7
                    ];
                    _ = ownedTokens.concat;
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .get_public_tokens_owned_by */ .lR)(publicKey)
                    ];
                case 6:
                    ownedTokens = _.apply(ownedTokens, [
                        _state.sent()
                    ]);
                    _state.label = 7;
                case 7:
                    ownedTokens = ownedTokens.filter(function(token) {
                        return token;
                    });
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .loadTokensData */ ._3)(ownedTokens)
                    ];
                case 8:
                    ownedTokens = _state.sent();
                    setTokens(ownedTokens);
                    setCollections(user_collections);
                    return [
                        3,
                        12
                    ];
                case 9:
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .get_user_privacy_prides */ .q9)(publicKey, requestRecords)
                    ];
                case 10:
                    private_tokens1 = _state.sent();
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .loadPrivacyPridesData */ .G8)(private_tokens1)
                    ];
                case 11:
                    ownedTokens1 = _state.sent();
                    console.log({
                        ownedTokens: ownedTokens1
                    });
                    setTokens(ownedTokens1);
                    setCollections([]);
                    _state.label = 12;
                case 12:
                    return [
                        3,
                        14
                    ];
                case 13:
                    e = _state.sent();
                    err_str = (e === null || e === void 0 ? void 0 : (ref = e.error) === null || ref === void 0 ? void 0 : ref.message) || (e === null || e === void 0 ? void 0 : e.message) || e + "";
                    alert.error(err_str);
                    if (is_private_tokens || is_externals_tokens) {
                        setFilterVal(0);
                    }
                    return [
                        3,
                        14
                    ];
                case 14:
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _loadUserWalletContent.apply(this, arguments);
}
var Trending_categories_items = function(param) {
    var category = param.category, setCategory = param.setCategory;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), tokens = ref[0], setTokens = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), collections = ref1[0], setCollections = ref1[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var trendingCategorySorText = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.counter;
    }).trendingCategorySorText;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), filterVal = ref2[0], setFilterVal = ref2[1];
    var ref3 = (0,_demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_7__/* .useWallet */ .Os)(), publicKey = ref3.publicKey, requestRecords = ref3.requestRecords;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_9__/* .useAlert */ .VY)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), ownedPublicLoading = ref5[0], setOwnedPublicLoading = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(dafault_tranding_category_filter_data), trandingCategoryFilter = ref6[0], setTrandingCategoryFilter = ref6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (category === 2) {
            setTrandingCategoryFilter(public_tranding_category_filter_data);
            setFilterVal(0);
        } else if (category === 4) {
            setTrandingCategoryFilter(private_tranding_category_filter_data);
            setFilterVal(1);
        } else {
            setTrandingCategoryFilter(dafault_tranding_category_filter_data);
        }
    }, [
        category
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        loadUserWalletContent(publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections);
    }, [
        filterVal,
        category,
        publicKey,
        requestRecords
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-8 flex flex-wrap items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "flex flex-wrap items-center",
                        children: trandingCategoryFilter.map(function(param) {
                            var id = param.id, svg = param.svg, text = param.text;
                            if (text === "all") {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "my-1 mr-2.5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: filterVal === id ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize" : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize",
                                        onClick: function() {
                                            setFilterVal(id);
                                        },
                                        children: text
                                    })
                                }, id);
                            } else {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "my-1 mr-2.5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            setFilterVal(id);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: filterVal === id ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize" : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                    style: {
                                                        transform: "translate(1px, 2px)"
                                                    },
                                                    className: filterVal === id ? "icon mr-1 h-5 w-5 transition-colors fill-white" : "icon fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                                        xlinkHref: "/icons.svg#icon-".concat(svg)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: text
                                                })
                                            ]
                                        })
                                    })
                                }, id);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-1 mr-2.5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: filterVal === 3 ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize" : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize",
                                    onClick: function() {
                                        setFilterVal(3);
                                    },
                                    children: "External NFTs"
                                })
                            })
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-jacarta-500"
                })
            }),
            !loading && tokens.length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-2xl font-semibold mb-2",
                            children: [
                                "No ",
                                filterVal === 0 ? "public" : filterVal === 1 ? "private" : "",
                                " token found"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-sm text-jacarta-500 dark:text-jacarta-400 normal-case ",
                            children: "Begin your journey by creating a new item"
                        })
                    ]
                })
            }),
            !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_categoryItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                tokens: tokens,
                collections: collections
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Trending_categories_items);


/***/ }),

/***/ 1843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);

var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9, _obj10, _obj11, _obj12;
var Feature_collections_data = [
    (_obj = {
        id: "0Art Me Outside",
        bigImage: "/images/collections/collection_1_1.jpg",
        subImage1: "/images/collections/collection_1_2.jpg",
        subImage2: "/images/collections/collection_1_3.jpg",
        subImage3: "/images/collections/collection_1_4.jpg",
        userImage: "/images/avatars/owner_5.png",
        userName: "Wow Frens",
        itemsCount: "10K",
        title: "Art Me Outside",
        category: "art"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "category", "Collectibles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "category", "photography"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "recent", true), _obj),
    (_obj1 = {
        id: "1PankySkal",
        bigImage: "/images/collections/collection_2_1.jpg",
        subImage1: "/images/collections/collection_2_2.jpg",
        subImage2: "/images/collections/collection_2_3.jpg",
        subImage3: "/images/collections/collection_2_4.jpg",
        userImage: "/images/avatars/owner_9.png",
        userName: "NFT stars",
        itemsCount: "2.8K",
        title: "PankySkal",
        category: "Collectibles"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, "category", "photography"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, "category", "music"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, "top", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, "trending", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, "recent", false), _obj1),
    (_obj2 = {
        id: "2VR Space_287",
        bigImage: "/images/collections/collection_3_1.jpg",
        subImage1: "/images/collections/collection_3_2.jpg",
        subImage2: "/images/collections/collection_3_3.jpg",
        subImage3: "/images/collections/collection_3_4.jpg",
        userImage: "/images/avatars/owner_4.png",
        userName: "Origin Morish",
        itemsCount: "8K",
        title: "VR Space_287",
        category: "domain"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, "category", "photography"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, "trending", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, "recent", true), _obj2),
    (_obj3 = {
        id: "3Metasmorf",
        bigImage: "/images/collections/collection_4_1.jpg",
        subImage1: "/images/collections/collection_4_2.jpg",
        subImage2: "/images/collections/collection_4_3.jpg",
        subImage3: "/images/collections/collection_4_4.jpg",
        userImage: "/images/avatars/owner_10.png",
        userName: "Lazy Panda",
        itemsCount: "1.5K",
        title: "Metasmorf",
        category: "music"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj3, "category", "photography"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj3, "category", "art"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj3, "top", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj3, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj3, "recent", false), _obj3),
    (_obj4 = {
        id: "43Landers",
        bigImage: "/images/collections/collection_5_1.jpg",
        subImage1: "/images/collections/collection_5_2.jpg",
        subImage2: "/images/collections/collection_5_3.jpg",
        subImage3: "/images/collections/collection_5_4.jpg",
        userImage: "/images/avatars/owner_11.png",
        userName: "051_Hart",
        itemsCount: "15K",
        title: "3Landers",
        category: "photography"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj4, "category", "Collectibles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj4, "category", "music"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj4, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj4, "trending", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj4, "recent", true), _obj4),
    (_obj5 = {
        id: "5SlimHoods",
        bigImage: "/images/collections/collection_6_1.jpg",
        subImage1: "/images/collections/collection_6_2.jpg",
        subImage2: "/images/collections/collection_6_3.jpg",
        subImage3: "/images/collections/collection_6_4.jpg",
        userImage: "/images/avatars/owner_3.png",
        userName: "Crytopank",
        itemsCount: "8.8K",
        title: "SlimHoods",
        category: "virtual world"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj5, "category", "music"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj5, "category", "art"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj5, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj5, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj5, "recent", false), _obj5),
    (_obj6 = {
        id: "6The Overseers",
        bigImage: "/images/collections/collection_7_1.jpg",
        subImage1: "/images/collections/collection_7_2.jpg",
        subImage2: "/images/collections/collection_7_3.jpg",
        subImage3: "/images/collections/collection_7_4.jpg",
        userImage: "/images/avatars/creator_2.png",
        userName: "Hey Mrsmeseks",
        itemsCount: "13K",
        title: "The Overseers",
        category: "art"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj6, "category", "Collectibles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj6, "top", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj6, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj6, "recent", true), _obj6),
    (_obj7 = {
        id: "7Dope Shibas",
        bigImage: "/images/collections/collection_8_1.jpg",
        subImage1: "/images/collections/collection_8_2.jpg",
        subImage2: "/images/collections/collection_8_3.jpg",
        subImage3: "/images/collections/collection_8_4.jpg",
        userImage: "/images/avatars/owner_12.png",
        userName: "alyxbow",
        itemsCount: "3K",
        title: "Dope Shibas",
        category: "Collectibles"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj7, "category", "art"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj7, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj7, "trending", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj7, "recent", true), _obj7),
    {
        id: "8Art Me Outside",
        bigImage: "/images/collections/collection_1_1.jpg",
        subImage1: "/images/collections/collection_1_2.jpg",
        subImage2: "/images/collections/collection_1_3.jpg",
        subImage3: "/images/collections/collection_1_4.jpg",
        userImage: "/images/avatars/owner_5.png",
        userName: "Wow Frens",
        itemsCount: "10K",
        title: "Art Me Outside",
        category: "art",
        top: true,
        trending: true,
        recent: false
    },
    {
        id: "9PankySkal",
        bigImage: "/images/collections/collection_2_1.jpg",
        subImage1: "/images/collections/collection_2_2.jpg",
        subImage2: "/images/collections/collection_2_3.jpg",
        subImage3: "/images/collections/collection_2_4.jpg",
        userImage: "/images/avatars/owner_9.png",
        userName: "NFT stars",
        itemsCount: "2.8K",
        title: "PankySkal",
        category: "Collectibles",
        top: false,
        trending: true,
        recent: true
    },
    (_obj8 = {
        id: "10VR Space_287",
        bigImage: "/images/collections/collection_3_1.jpg",
        subImage1: "/images/collections/collection_3_2.jpg",
        subImage2: "/images/collections/collection_3_3.jpg",
        subImage3: "/images/collections/collection_3_4.jpg",
        userImage: "/images/avatars/owner_4.png",
        userName: "Origin Morish",
        itemsCount: "8K",
        title: "VR Space_287",
        category: "domain"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj8, "category", "Collectibles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj8, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj8, "trending", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj8, "recent", true), _obj8),
    (_obj9 = {
        id: "11Metasmorf",
        bigImage: "/images/collections/collection_4_1.jpg",
        subImage1: "/images/collections/collection_4_2.jpg",
        subImage2: "/images/collections/collection_4_3.jpg",
        subImage3: "/images/collections/collection_4_4.jpg",
        userImage: "/images/avatars/owner_10.png",
        userName: "Lazy Panda",
        itemsCount: "1.5K",
        title: "Metasmorf",
        category: "music"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj9, "category", "Collectibles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj9, "category", "virtual world"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj9, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj9, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj9, "recent", false), _obj9),
    (_obj10 = {
        id: "123Landers",
        bigImage: "/images/collections/collection_5_1.jpg",
        subImage1: "/images/collections/collection_5_2.jpg",
        subImage2: "/images/collections/collection_5_3.jpg",
        subImage3: "/images/collections/collection_5_4.jpg",
        userImage: "/images/avatars/owner_11.png",
        userName: "051_Hart",
        itemsCount: "15K",
        title: "3Landers",
        category: "photography"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj10, "category", "domain"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj10, "category", "virtual world"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj10, "top", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj10, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj10, "recent", true), _obj10),
    (_obj11 = {
        id: "13SlimHoods",
        bigImage: "/images/collections/collection_6_1.jpg",
        subImage1: "/images/collections/collection_6_2.jpg",
        subImage2: "/images/collections/collection_6_3.jpg",
        subImage3: "/images/collections/collection_6_4.jpg",
        userImage: "/images/avatars/owner_3.png",
        userName: "Crytopank",
        itemsCount: "8.8K",
        title: "SlimHoods",
        category: "virtual world"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj11, "category", "domain"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj11, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj11, "trending", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj11, "recent", true), _obj11),
    (_obj12 = {
        id: "14The Overseers",
        bigImage: "/images/collections/collection_7_1.jpg",
        subImage1: "/images/collections/collection_7_2.jpg",
        subImage2: "/images/collections/collection_7_3.jpg",
        subImage3: "/images/collections/collection_7_4.jpg",
        userImage: "/images/avatars/creator_2.png",
        userName: "Hey Mrsmeseks",
        itemsCount: "13K",
        title: "The Overseers",
        category: "domain"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj12, "category", "virtual world"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj12, "top", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj12, "trending", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj12, "recent", false), _obj12), 
];
/* harmony default export */ __webpack_exports__["Z"] = (Feature_collections_data);


/***/ })

}]);